<template>
<div class="consent_banner mt_1">
    <div class="container">

        <div class="row mx_0_5">
            <div class="col px_1 pt_1">
                <p>
                    <span class="text_b">Einbindung externer Inhalte</span><br>
                    Auf dieser Website sind Inhalte von YouTube und Google Maps eingebettet.
                    Diese werden erst geladen, wenn du zustimmst.
                    Dabei können personenbezogene Daten an die jeweiligen Anbieter übermittelt werden.
                    Mehr Infos findest du in unserer
                    <router-link :to="{ name: 'datenschutz' }" class="link">Datenschutzerklärung</router-link>.<br>
                    Möchtest du die Inhalte aktivieren?
                </p>
            </div>
        </div>
        <div class="row mx_0_5">
            <div class="col_12 col_sm_6 px_1 pb_1 pt_0_5">
                <button class="btn" :class="{ active: consentStatus === 'accepted' }" @click="acceptConsent">
                    Ja, Inhalte laden {{ consentStatus === 'accepted' ? '(gewählt)' : '' }}
                </button>
            </div>
            <div class="col_12 col_sm_6 px_1 pb_1 pt_sm_0_5">
                <button class="btn" :class="{ active: consentStatus === 'rejected' }" @click="rejectConsent">
                    Nein, Inhalte blockieren {{ consentStatus === 'rejected' ? '(gewählt)' : '' }}
                </button>
            </div>
        </div>

    </div>
</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

export default defineComponent({
    name: 'ConsentBanner',

    props: {
        consentStatus: {
            type: String as PropType<'accepted' | 'rejected' | null>,
            required: true
        }
    },
    
    methods: {
        acceptConsent() {
            this.$emit('select-consent', 'accepted');
        },

        rejectConsent() {
            this.$emit('select-consent', 'rejected');
        }
    }
});
</script>

<style scoped>
.consent_banner {
    position: sticky;
    bottom: 0;
    z-index: 9999;
    background-color: var(--global_component_bg_color);
    color: var(--color_white);
    box-shadow: 0 0.125rem 1rem var(--shadow_color);
}

.btn.active {
    background-color: rgba(var(--color_gold_rgb), 0.25);
    border-color: var(--color_gold);
}
</style>
